import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FiSettings } from "react-icons/fi";
import { CgCalendarDates } from "react-icons/cg";
import { AiOutlineSchedule } from "react-icons/ai";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { FaTasks } from "react-icons/fa";
// import { TbReportSearch, TbReport } from "react-icons/tb";
import { FaPlus } from "react-icons/fa";
import { AiOutlineFileSearch } from "react-icons/ai";
import { getAllTaskRevert } from "app/_services/ehs/ehsEventScheduleServices";
import { GoStop, GoReport } from "react-icons/go";
import { BiCalendar, BiIdCard } from "react-icons/bi";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { getAllEvents } from "app/_services/ehs/ehsEventServices";
import { getAllEventSchedules } from "app/_services/ehs/ehsEventScheduleServices";
import { MEETING_STATUS } from "./CONSTANT";
import localStorageService from "app/services/localStorageService";
import { ACTIVE_MODULE } from "app/_constants/constant";

const EHSAuditsMeetings = ({
  match: {
    params: { siteId },
  },
}) => {
  const [events, setEvents] = useState([]);
  const [incidents, setIncidents] = useState([]);
  const [count, setCount] = useState([]);
  const [revertData, setRevertData] = useState([]);
  const showEditIcon = useCallback((row) => {
    let showEdit = false;
    let tabNumber = null;
    const permissions = localStorageService.getItem("permissions");

    if (
      permissions[row?.event?.scheduler] &&
      (row.eventStatus === MEETING_STATUS.scheduled ||
        row.eventStatus === MEETING_STATUS.draft)
    ) {
      showEdit = true;
      tabNumber = 1;
    }
    if (
      permissions[row?.event?.reviewer] &&
      row.eventStatus === MEETING_STATUS.inProgress &&
      row.reviewer === 1
    ) {
      showEdit = true;
      tabNumber = 2;
    }
    if (
      permissions[row?.event?.approver] &&
      (row.eventStatus === MEETING_STATUS.planned ||
        (row.eventStatus === MEETING_STATUS.inProgress &&
          (row.reviewer !== 1 || row?.isReviewed === 1)) ||
        row.eventStatus === MEETING_STATUS.reviewed)
    ) {
      showEdit = true;
      tabNumber = 3;
    }

    return { showEdit, tabNumber };
  }, []);

  useEffect(() => {
    getAllEvents("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setEvents(response.data);
    });

    getAllEventSchedules().then((response) => {
      if (!response?.data) return;
      setIncidents(
        response.data.map((inc, idx) => ({
          ...inc,
          sid: idx + 1,
          // eventStatusView: MEETING_STATUS_VIEW[inc?.eventStatus],
        }))
      );
    });
    getAllTaskRevert().then((response) => {
      if (!response?.data) return;
      setRevertData(response?.data);
    });
  }, []);

  const myApprovalCount = useMemo(() => {
    let count = incidents.filter((row) => {
      const { showEdit } = showEditIcon(row);

      return showEdit ? true : false;
    }).length;
    count = count + revertData.length;

    return `${count > 100 ? "" : count > 10 ? "0" : "00"}${count}`;
  }, [incidents, showEditIcon, revertData]);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          { name: "OHSE Review" },
        ]}
        module={ACTIVE_MODULE.ohse}
      />
      <div className="manageBtnScreen">
        <Row>
          {events.length > 0 && (
            <Col lg={4} className="mb-4">
              <Link
                to={
                  (siteId ? `/sites/${siteId}` : "") +
                  "/health-safety-and-environment/audits-meetings/scheduled-event"
                }
                className="btn manage-btn"
              >
                <AiOutlineSchedule /> Schedule OHSE Review
              </Link>
            </Col>
          )}
          <Col lg={4} className="mb-4">
            <Link
              to={"/health-safety-and-environment/audits-meetings/my-approval"}
              className="d-block btn manage-btn"
            >
              <GoStop />
              <span>My Approval Actions</span>

              <span className="tabText">
                {myApprovalCount} &nbsp;Workflow actions Due
              </span>
            </Link>
          </Col>
          <Col lg={4} className="mb-4">
            <Link
              to={"/health-safety-and-environment/audits-meetings/my-approval-history"}
              className="btn manage-btn"
            >
              <AiOutlineFileSearch />
              My Approval History
            </Link>
          </Col>{" "}
          <Col lg={4} className="mb-4">
            <Link
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/audits-meetings/my-events"
              }
              className="btn manage-btn"
            >
              <GoReport />
              MY OHSE Review
            </Link>
          </Col>
          <Col lg={4} className="mb-4">
            <Link
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/audits-meetings/views"
              }
              className="btn manage-btn"
            >
              <HiOutlineDocumentReport /> View OHSE Reviews
            </Link>
          </Col>
          <Col lg={4} className="mb-4">
            <Link
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/audits-meetings/view-tasks"
              }
              className="btn manage-btn"
            >
              <FaTasks /> OHSE Review TASKS
            </Link>
          </Col>
          <Col lg={4} className="mb-4">
            <Link
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/audits-meetings/calendar"
              }
              className="btn manage-btn"
            >
              <CgCalendarDates /> OHSE Review Calendar
            </Link>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default connect((state) => ({ user: state.user.user }))(EHSAuditsMeetings);
